<!-- Iris inline answer card -->
@if (irisEnabled()) {
    <jhi-global-search-iris-answer [searchQuery]="searchQuery()" />
}

<!-- Action button: Search Lecture Content (visible when iris enabled and no filter active) -->
@if (irisEnabled() && showLectureButton()) {
    <div #selectableItem>
        <jhi-global-search-action-item
            [title]="'global.search.actions.lectureSearchTitle' | artemisTranslate"
            [description]="'global.search.actions.lectureSearchDescription' | artemisTranslate"
            [selected]="selectedIndex() === LECTURE_SEARCH_ACTION_INDEX"
            accentColor="var(--global-search-lecture-accent)"
            secondaryAccentColor="var(--bs-primary)"
            (clicked)="viewSelected.emit(SearchView.Lecture)"
        >
            <fa-icon slot="icon" [icon]="faFileLines" aria-hidden="true" />
        </jhi-global-search-action-item>
    </div>
}

<!-- Error state -->
@if (searchError()) {
    <div class="search-error-state mt-3 p-3 text-center text-danger">
        <p>{{ searchError()! | artemisTranslate }}</p>
    </div>
}

<!-- Results list when searching or filter is active -->
@if (showResults() && !isLoading() && !searchError()) {
    @if (results().length > 0) {
        <div class="search-results-list" [class.mt-3]="irisEnabled()">
            @for (result of results(); track result.id; let i = $index) {
                <div #selectableItem>
                    <jhi-global-search-result-item
                        [result]="result"
                        [icon]="getIconForType(result.type, result.badge)"
                        [isSelected]="selectedIndex() === actionButtonCount() + i"
                        (resultClick)="navigateToResult($event)"
                    />
                </div>
            }
        </div>
    } @else {
        <div class="no-results-state p-3 text-center text-secondary" [class.mt-3]="irisEnabled()">
            @if (isTooShortQuery()) {
                <p>{{ 'global.search.tooShortQueryHint' | artemisTranslate }}</p>
            } @else {
                <p>{{ 'global.search.noResultsFound' | artemisTranslate }}</p>
                @if (isShortQuery()) {
                    <p class="text-body-tertiary small">{{ 'global.search.shortQueryHint' | artemisTranslate }}</p>
                }
            }
        </div>
    }
} @else if (isLoading()) {
    <!-- Skeleton loading placeholders -->
    <div class="search-results-list" [class.mt-3]="irisEnabled()">
        @for (_ of skeletonItems; track $index) {
            <div class="skeleton-result-item p-3" aria-hidden="true">
                <div class="d-flex align-items-start gap-3">
                    <!-- Icon placeholder -->
                    <p-skeleton width="2.5rem" height="2.5rem" borderRadius="0.375rem" class="flex-shrink-0" />
                    <!-- Content placeholder -->
                    <div class="d-flex flex-column flex-grow-1" style="gap: 0.5rem">
                        <div class="d-flex align-items-center gap-2">
                            <p-skeleton width="45%" height="1rem" borderRadius="0.25rem" />
                            <p-skeleton width="4.5rem" height="1.25rem" borderRadius="0.25rem" />
                        </div>
                        <p-skeleton width="65%" height="0.75rem" borderRadius="0.25rem" />
                        <p-skeleton width="80%" height="0.75rem" borderRadius="0.25rem" />
                    </div>
                </div>
            </div>
        }
    </div>
} @else {
    <!-- Searchable entities list (initial state) -->
    <div class="entity-list" [class.mt-3]="irisEnabled()">
        @for (entity of searchableEntities; track entity.id; let i = $index) {
            <div #selectableItem>
                <jhi-global-search-entity-item [entity]="entity" [isSelected]="selectedIndex() === actionButtonCount() + i" (entityClick)="onEntityItemClick($event)" />
            </div>
        }
    </div>
}
